<template>
  <BootstrapTable
    :columns="columns"
    :data-url="data"
    :options="options"
  />
</template>

<script>
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'

export default {
  components: {
    BootstrapTable
  },
  data () {
    return {
      columns: [
        {
          field: 'name',
          title: 'Template Deck Name',
          sortable: true,
        },
        {
          field: 'updated_at',
          title: 'Last Modified At',
          sortable: true,
          formatter: function(value, row, index){
            
            if(value !== null){

              value = new Date( value.replace(/-/g, "/") + ' UTC');

              value = value.getDate()+'/'+(value.getMonth()+1)+'/'+value.getFullYear()+' '+value.getHours()+':'+ (value.getMinutes()<10?'0':'') + value.getMinutes();
            }

            return value;
          }
        },
        {
          field: 'created_at',
          title: 'Created At',
          sortable: true,
          formatter: function(value, row, index){
            
            if(value !== null){

              value = new Date( value.replace(/-/g, "/") + ' UTC');

              value = value.getDate()+'/'+(value.getMonth()+1)+'/'+value.getFullYear()+' '+value.getHours()+':'+ (value.getMinutes()<10?'0':'') + value.getMinutes();
            }

            return value;
          }
        },
        {
          field: 'tools',
          title: 'Tools',
          formatter: function(value, row, index){
            return [
                '<a class="table-control btn btn-outline-primary btn-sm" href="/deck/edit/'+row.deck_id+'" title="View & Edit Template">',
                '<i class="fa fa-edit"></i>',
                '</a>',
                ' <a class="table-control btn btn-outline-secondary btn-sm" href="/deck/duplicate/'+row.deck_id+'" title="Copy Template as New Draft Deck">',
                '<i class="fa fa-copy"></i>',
                '</a>',
                ' <a class="table-control btn btn-outline-danger btn-sm" href="/deck/delete/'+row.deck_id+'" title="Delete Template">',
                '<i class="fa fa-trash-o"></i>',
                '</a>'
              ].join('');
          },
          width: 130,
          align: 'center'
        }
      ],
      data: '/deck/templates/list',
      options: {
        search: true,
        formatNoMatches: function(){
          return 'No Template Decks Found. <br /> To create a template, <a href="/deck/new">Create a New Deck</a> (or edit an <a href="/deck/drafts">Existing Draft Deck</a>) and Click the Settings Button <i class="fa fa-cog"></i> in the SizzleDeck Builder.';
        },
      }
    }
  }
}




</script>